/* Util functions to support The Financial Wellness Center */

export const toArray = (list) => [].slice.call(list)

export const oddOrEven = (num) => {
  return num % 2 == 1 ? "odd" : "even"
}

export const gridLayout = (count) => {
  const remainder = count % 3
  if (remainder === 0) {
    return "plus-3" // 3, 6, 9, 12... - All uniform 3-column grid
  } else if (remainder === 2) {
    return "plus-5" // 2, 5, 8, 11... - First row has 2 cards, rest are 3-column
  } else if (remainder === 1) {
    return "plus-7" // 1, 4, 7, 10... - First row has 1 large card, rest are 3-column
  } else {
    return "plus-3" // Fallback to uniform grid
  }
}

export const getMetaContentByName = (name) => {
  const sel = document.querySelector("meta[name='" + name + "']")
  return sel ? sel.getAttribute("content") : null
}

export const setParam = (param, value) => {
  if ("URLSearchParams" in window) {
    var searchParams = new URLSearchParams(window.location.search)
    searchParams.set(param, value)
    var newRelativePathQuery = window.location.pathname + "?" + searchParams.toString()
    history.pushState(null, "", newRelativePathQuery)
  }
}

export const getParam = (param) => {
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.get(param)
}
